import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SampleService } from '../../core/http/sample.service';
import { SettingsService } from '../../core/http/settings.service';
import { BillingService } from '../../core/http/billing.service';
import { AuthServiceService } from '../../core/http/auth-service.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ObsService } from '../../core/http/obs.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { environment } from '../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { SendReviewComponent } from '../../shared/components/send-review/send-review.component';

import * as _moment from 'moment';
import { FinalizeModalComponent } from 'src/app/shared/components/finalize-modal/finalize-modal.component';
import { Location } from '@angular/common';
const moment = _moment;

@Component({
  selector: 'app-x-ray',
  templateUrl: './x-ray.component.html',
  styleUrls: ['./x-ray.component.scss'],
})
export class XRayComponent implements OnInit {
  dept_code = 1;
  depts: any = [];
  isLoading = true;
  sendLoad = false;
  isSaveLoading = false;
  mode = 'form';
  Errors = null;
  data: any = [];
  samples: any = [];
  Success;
  billId;
  message;
  sex = '';
  name = '';
  phone = '';
  record: any = [];
  templates: any = [];
  startdate = '';
  enddate = '';
  details;
  isSelected: boolean = true;
  drs: any = [];
  dr = '';
  initialdr = '';
  result_id;
  signatureImage;
  imageError: string;
  isImageSaved: boolean;
  cardImageBase64: any;
  loading: boolean = false;
  deleteLoad: boolean = false;
  companyDetail;
  image;
  file: any = [];
  fileName: string = '';
  userdrId = 0;
  initializerId = 0;
  valueE;
  private baseURL = environment.urls.api_main;
  resultSaved = false;
  finalizeLoading = false;

  Template_Text = '';

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '300px',
    minHeight: '300px',
    maxHeight: '300px',
    width: 'auto',
    minWidth: 'auto',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    ],
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['insertImage', 'insertVideo', 'insertHorizontalRule', 'removeFormat'],
    ],
  };

  stateForm = new FormGroup({
    sample_id: new FormControl('', Validators.required),
    format_code: new FormControl(''),
    formatstr: new FormControl(this.Template_Text, Validators.required),
    result_id: new FormControl('', Validators.required),
  });
  currentDateTime = new Date();
  comment: any;
  otherData;

  currentPage: number = 1;
  totalSize: number = 1;
  pageSize: number = 100;
  onPageChanged(newPage: number) {
    this.getResult(newPage);
  }
  constructor(
    private http: HttpClient,
    public router: Router,
    private obs: ObsService,
    private sample: SampleService,
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public setting: SettingsService,
    public auth: AuthServiceService,
    public bill: BillingService,
    public sant: DomSanitizer,
    private location: Location
  ) {}

  ngOnInit(): void {
    const currentDate = moment();
    const twoMonthsAgo = moment(currentDate).subtract(2, 'months');
    this.startdate = twoMonthsAgo.format('YYYY-MM-DD');
    this.enddate = currentDate.format('YYYY-MM-DD');
    this.setting.getDept().subscribe(
      (resSuccess) => {
        this.depts = resSuccess;
        console.log(resSuccess);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
    this.sample.getResults(this.startdate, this.enddate, this.dept_code).subscribe(
      (resSuccess: any) => {
        this.data = resSuccess.data;
        if (resSuccess.metadata) {
          this.currentPage = resSuccess.metadata.page;
          this.totalSize = resSuccess.metadata.total;
          this.pageSize = resSuccess.metadata.pagesize;
        }
        this.isLoading = false;
        console.log(resSuccess);
        console.log(this.data);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.sample.getDrs().subscribe(
      (resSuccess: any) => {
        // this.data = resSuccess
        this.drs = resSuccess;
        this.isLoading = false;
        console.log(resSuccess);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }

  
  getResult(pageno=1) {
    this.data = [];
    this.isLoading = true;
    this.sample
      .searchResults(
        this.startdate,
        this.enddate,
        this.name,
        this.phone,
        this.sex,
        this.dept_code,
        pageno,
        this.pageSize
      )
      .subscribe(
        (resSuccess: any) => {
          this.data = resSuccess.data;
          if (resSuccess.metadata) {
            this.currentPage = resSuccess.metadata.page;
            this.totalSize = resSuccess.metadata.total;
            this.pageSize = resSuccess.metadata.pagesize;
          }

          this.isLoading = false;
          console.log(resSuccess);
          console.log(this.data);
          this.isLoading = false;
        },
        (resErr) => {
          this.Errors = resErr;
          this.isLoading = false;
        }
      );
  }

  startDateChange(event: any) {
    this.startdate = moment(event.target.value).format('YYYY-MM-DD');
    console.log(this.startdate);
  }
  endDateChange(event: any) {
    this.enddate = moment(event.target.value).format('YYYY-MM-DD');
    console.log(this.enddate);
  }

  // itemChange(value) {
  //   if(value == "") {
  //     this.drVisible = false
  //   }else {
  //     this.drVisible = true
  //   }
  //   this.filterddata = this.items.filter(t => t.name.toLowerCase().indexOf(value.toLowerCase()) !== -1)
  //   console.log(value);

  // }

  getTemplate(code) {
    this.sample.getTemplate(code).subscribe(
      (resSuccess: any) => {
        this.templates = resSuccess;
        this.Template_Text = resSuccess[0].Template_Text;
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }

  getDetails(result_id) {
    this.sample.getdetails(result_id).subscribe(
      (resSuccess) => {
        this.details = resSuccess;
        this.Template_Text = this.details.data;
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }

  getFile(result_id) {
    this.message = [];
    this.sample.getFile(result_id).subscribe(
      (resSuccess) => {
        this.message = resSuccess;
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }
  addRecord(item) {
    this.record = item;
    // if (item.service_name === "Obstetric") {
    //   this.obs.addItem(item);
    //   this.router.navigateByUrl("/obs", { state: { patient: item } });
    // }else {
    this.result_id = item.result_id;
    this.mode = 'wiz';
    this.Errors = '';
    this.isSelected = true;
    this.getTemplate(item.service_code);
    this.getDetails(item.result_id);
    this.getFile(item.result_id);
    this.stateForm.patchValue({
      sample_id: item.sample_id,
      format_code: item.format_code,
      result_id: item.result_id,
    });
    console.log(item);
    this.billId = item.bill_id;
    // }
  }
  back() {
    this.mode = 'form';
    this.Template_Text = '';
  }
  done() {
    this.stateForm.patchValue({
      formatstr: this.Template_Text.replace(/"/g, "'"),
    });
    console.log(this.stateForm.value);
    this._snackBar.open('Template Added Successfully', '', {
      duration: 2000,
      verticalPosition: 'top',
    });
  }
  setTemplate(template) {
    this.Template_Text = template.Template_Text.replace(/"/g, "'");
    this.isSelected = false;
    console.log(this.Template_Text);
  }

  isWithinLastWeek(dateStr: string): boolean {
    const fourHoursAgo = new Date(
      this.currentDateTime.getTime() - 4 * 60 * 60 * 1000 // 4 hours in milliseconds
    );
    const targetDate = new Date(dateStr);
    return targetDate >= fourHoursAgo && targetDate <= this.currentDateTime;
  }

  getRowClass(item: any): string {
    const typed = item.service.prepared ? item.service.prepared === 'Y' : false;

    const finalized = item.service.finalized_timestamp
      ? item.service.finalized_timestamp
      : false;
    const online = item?.pushedOnlineStatus ? item?.pushedOnlineStatus : false;
    const printed = item.service.printed ? item.service.printed === 'Y' : false;

    // Priority is defined by the order of these conditions
    if (online) return 'verified';
    if (printed) return 'printed';
    if (finalized) return 'finalized';
    if (typed) return 'prepared';

    return '';
  }

  openFinalize() {
    if (this.resultSaved === true) {
      console.log(this.billId, 'nnnnnnnnnn');
      this.modal.openModal(FinalizeModalComponent, 'modal', {
        id: this.billId,
      });
    } else {
      this.Submit();
    }
  }

  drValue(e) {
    this.valueE = e;
    this.userdrId = e.value;
  }
  initatorValue(e) {
    this.valueE = e;
    this.initializerId = e.value;
    // this.override();
  }

  override() {
    this.setting
      .postOverideFinializer(
        this.result_id,
        this.initializerId,
        this.userdrId,
        this.comment
      )
      .subscribe(
        (resSuccess) => {
          this.otherData = resSuccess;
          this.isLoading = false;

          if (this.otherData.success) {
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            window.location.reload();
          } else {
            this.Errors = 'Not successful, please try again';
            console.log('error');
          }
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          console.log(resErr);
        }
      );
  }

  finalize() {
    // if (this.resultSaved === true) {
    this.Submit();
    console.log(this.userdrId);
    let user_id = this.userdrId;
    let result_id = this.result_id;
    let is_finalized = true;
    // if (!this.userdrId) {
    //   this._snackBar.open('Select a Doctor', '', {
    //     duration: 2000,
    //     verticalPosition: 'top',
    //   });
    // } else {
    this.sample
      .postResultFinalizeScan(result_id, is_finalized, user_id)
      .subscribe(
        (resSuccess: any) => {
          console.log(resSuccess);
          this.finalizeLoading = true;
          if (resSuccess.success) {
            this.finalizeLoading = false;
            this.finalize1(this.valueE);
            this.override();
            this._snackBar.open('Result finalized succesfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            console.log('error');
            this.finalizeLoading = false;
          }
        },
        (resErr) => {
          this.finalizeLoading = false;
          this.sendLoad = false;
          this.Errors = resErr;
          this._snackBar.open('error: please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resErr);
        }
      );
    // }
    // } else {
    //   this.Submit();
    // }
  }

  finalize1(e) {
    let user_id = e.value;
    let result_id = this.result_id;
    let is_finalized = true;
    this.sample
      .postResultFinalizeScan(result_id, is_finalized, user_id)
      .subscribe(
        (resSuccess: any) => {},
        (resErr) => {
          this.Errors = resErr;
          this._snackBar.open('error: please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      );
  }

  Submit() {
    console.log(this.stateForm.value);
    this.done();
    this.sendLoad = true;
    this.Errors = null;
    this.Success = null;
    const { sample_id, format_code, formatstr, result_id } =
      this.stateForm.value;
    this.sample.postResultDetail(result_id, formatstr).subscribe(
      (resSuccess: any) => {
        this.sendLoad = false;
        console.log(resSuccess);

        if (resSuccess.success) {
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          this.getResult();
          this.resultSaved = true;
        } else {
          this.Errors = 'Not successful, please try again';
          console.log('error');
          this._snackBar.open('Error Please Try Agian', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      },
      (resErr) => {
        this.sendLoad = false;
        this.Errors = resErr;
        this._snackBar.open('error: please try again', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
  }

  SendReview() {
    if (this.resultSaved === true) {
      const data = {
        resultId: this.record.result_id,
        body: this.Template_Text,
      };
      this.modal.openModal(SendReviewComponent, 'modal', data);
      console.log(this.record.result_id);
    } else {
      this.Submit();
    }
  }

  onSubmit() {
    let fileName = this.fileName;
    // let fileBase64str = this.cardImageBase64.substring(22);
    let fileBase64str = this.cardImageBase64;
    const { result_id } = this.stateForm.value;
    this.sample.fileSave(result_id, fileName, fileBase64str).subscribe(
      (resSuccess: any) => {
        this.message = resSuccess[0];
        this.isSaveLoading = false;
        console.log(resSuccess);
        this.getFile(result_id);
        if (this.message) {
          this._snackBar.open('file Uploaded successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      },
      (resErr) => {
        this.isSaveLoading = false;
        this.Errors = resErr;
        this._snackBar.open('error: please try again', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          #print-section {
            width: 500px;
          }
          </style>
        </head>
    <body onload="window.print()">${printContents}</body>
      </html>`);
    popupWin.document.close();
  }

  // showImage1(data) {
  //   this.signatureImage = data;
  //   this.toastr.success("Signature Added", "")
  //   this.form.patchValue({
  //     signature: data
  // });
  // console.log(this.form.value);

  // }
  public fileLeave(event) {
    console.log(event);
  }

  fileChangeEvent(fileInput: any) {
    this.imageError = null;
    let file = fileInput.target.files[0];
    console.log(file);

    this.cardImageBase64 = this.sant.bypassSecurityTrustUrl(
      window.URL.createObjectURL(file)
    ) as String;
    let reader = new FileReader();
    reader.readAsDataURL(file as Blob);
    reader.onloadend = () => {
      this.cardImageBase64 = reader.result as String;
      if (fileInput.target.files[0].type == 'image/png') {
        this.fileName = fileInput.target.files[0].name;
        this.cardImageBase64 = this.cardImageBase64.substring(22);
        this.onSubmit();
      } else if (fileInput.target.files[0].type == 'image/jpg') {
        this.cardImageBase64 = this.cardImageBase64.substring(22);
        this.fileName = fileInput.target.files[0].name;
        this.onSubmit();
      } else if (fileInput.target.files[0].type == 'image/jpeg') {
        this.cardImageBase64 = this.cardImageBase64.substring(23);
        this.fileName = fileInput.target.files[0].name;
        this.onSubmit();
      } else {
        this._snackBar.open(
          'error: please select a png, jpeg or jpg file',
          '',
          {
            duration: 2000,
            verticalPosition: 'top',
          }
        );
        return;
      }
    };
  }

  removeImage() {
    // this.form.patchValue({
    //   logo: ""
    // })
    // this.deleteLoad = true
    // this.company.saveCompany(this.form.value).subscribe(data => {
    //   this.deleteLoad = false
    //   this.data = data
    //   if(this.data.isSuccessful) {
    //     this.toastr.success("logo Removed Successfully", "Yoopee")
    //     this.modal.closeModal()
    //     this.form.reset()
    //   }else {
    //   }
    //   console.log(this.data);
    // });
    // }
  }
}
